import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from '../../app-routing.module';
import { HeaderAlertModule, TitleBarModule, SpinnerModule, DfMonthPickerModule, LoadingErrorModule, PipesModule, StoreProviderModule, MenuModule, ExceptionsModule, NgbCompatModule } from '@uxdf/direct-shared-lib';
import { AgreementBannerComponent } from './banners/agreement/agreement-banner.component';
import { AlertBannerComponent } from './banners/alert-banner/alert-banner.component';
import { DirectTimeoutBannerComponent } from './banners/direct-timeout-banner/direct-timeout-banner.component';
import { MaintenanceComponent } from './exceptions/maintenance/maintenance.component';
import { HomepageComponent } from './homepage/homepage.component';
import { ExceptionsComponent } from './exceptions/exceptions.component';
import { FooterComponent } from './homepage-layout/footer/footer.component';
import { HeaderDirectComponent } from './homepage-layout/header/header-direct.component';
import { HeaderSearchComponent } from './homepage-layout/header-search/header-search.component';
import { MobileMenuComponent } from './homepage-layout/mobile-menu/mobile-menu.component';
import { SideMenuComponent } from './homepage-layout/side-menu/side-menu.component';
import { HomepageLayoutComponent } from './homepage-layout/homepage-layout.component';
import { LoyaltyApproveTileComponent } from './tiles/loyalty/loyalty-approve-tile/loyalty-approve-tile.component';
import { LoyaltyEnrollmentTileComponent } from './tiles/loyalty/loyalty-enrollment-tile/loyalty-enrollment-tile.component';
import { LoyaltyPointsTileComponent } from './tiles/loyalty/loyalty-points-tile/loyalty-points-tile.component';
import { LoyaltyTileComponent } from './tiles/loyalty/loyalty-tile.component';
import { LoyaltyRequestTileComponent } from './tiles/loyalty/loyalty-request-tile/loyalty-request-tile.component';
import { NewsTileComponent } from './tiles/news/news-tile.component';
import { TileSsoComponent } from './tiles/sso/tile-sso.component';
import { TileComponent } from './tiles/tile/tile.component';
import { TilesComponent } from './tiles/tiles.component';
import { CartWidgetComponent } from './widgets/cart/cart-widget.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BannerTileComponent } from './tiles/banner/banner-tile.component';
import { LoyaltyWidgetComponent } from '../loyalty/widget/loyalty-widget.component';
import { BookModule } from '../book/book.module';
import { DashboardModule } from '../dashboard/dashboard.module';
import { ReefI18nModule, ReefAppModule } from '@seco/core';
import { NgxPageScrollModule } from 'ngx-page-scroll';
import { LoyaltyModule } from '../loyalty/loyalty.module';
import { DfAlertModule, DfSelectModule, DfMediaModule } from '@design-factory/design-factory';
import { DoughnutChartModule } from '../../directives/doughnutChart.module';
import { AnalyticsModule } from '@seco/dev-utils';
import { NgSelectModule } from '@ng-select/ng-select';
import { FeatureToggleModule } from 'ngx-feature-toggle';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NavbarModule, ConfirmAlertModule } from '@uxdf/p-components';
import { CsvModule } from '@ctrl/ngx-csv';
import { NgScrollbarModule } from 'ngx-scrollbar';


@NgModule({
  declarations: [
    AgreementBannerComponent,
    AlertBannerComponent,
    DirectTimeoutBannerComponent,
    MaintenanceComponent,
    ExceptionsComponent,
    HomepageComponent,
    FooterComponent,
    HeaderDirectComponent,
    HeaderSearchComponent,
    MobileMenuComponent,
    SideMenuComponent,
    HomepageLayoutComponent,
    LoyaltyApproveTileComponent,
    LoyaltyEnrollmentTileComponent,
    LoyaltyPointsTileComponent,
    LoyaltyTileComponent,
    LoyaltyRequestTileComponent,
    NewsTileComponent,
    TileSsoComponent,
    TileComponent,
    TilesComponent,
    CartWidgetComponent,
    BannerTileComponent,
    LoyaltyWidgetComponent
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    TitleBarModule,
    NgbCompatModule,
    HeaderAlertModule,
    FormsModule,
    ReactiveFormsModule,
    BookModule,
    DashboardModule,
    SpinnerModule,
    ReefI18nModule,
    NgScrollbarModule,
    NgxPageScrollModule,
    NgSelectModule,
    DfMonthPickerModule,
    FeatureToggleModule,
    NgxPermissionsModule.forRoot(),
    NavbarModule,
    ConfirmAlertModule,
    LoadingErrorModule,
    PipesModule,
    StoreProviderModule,
    MenuModule,
    ExceptionsModule,
    DfSelectModule,
    CsvModule,
    DfMediaModule,
    ReefAppModule.forRoot(),
    AnalyticsModule,
    DoughnutChartModule,
    DfAlertModule,
    LoyaltyModule
  ],
  exports: [HomepageLayoutComponent]
})
export class HomepageModule {}
